import { getBrandSellData } from "utils/getBrandSellData";
import { Navigate, useLocation } from "react-router";
import { INTERNAL_PATHS } from "routes/paths";
import { Breadcrumb } from "components/UI/molecules";
import { BREADCRUMB_PATHS } from "./utils/constants";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";
import { capitalizeFirstLetter } from "utils/strings";

export const SellBrandGiftCards = () => {
  const { pathname } = useLocation();
  const brandNameRegex = /\/sell-(.*?)-gift-cards/i;
  const brandName = (() => pathname.match(brandNameRegex)[1])();
  const brandData = getBrandSellData(brandName);

  return brandData ? (
    <div className="sell-brand-gift-cards">
      <ReactHelmetWithProvider>
        <title>Sell {capitalizeFirstLetter(brandName)} Gift Cards | GCX</title>
        <link rel="canonical" href={process.env.REACT_APP_URL + pathname} />
      </ReactHelmetWithProvider>
      <Breadcrumb
        customClassname="breadcrumb-sell-brand"
        list={[
          ...BREADCRUMB_PATHS,
          {
            label: `${brandData.name} Gift Cards`,
            linkTo: window.location.href
          }
        ]}
      />
    </div>
  ) : (
    <Navigate to={INTERNAL_PATHS.NOT_FOUND} />
  );
};
